//
export default {
    //
    product: [
        {
            text: 'código interno',
            value: 'internal_code',
            width: '15%',
        },
        {
            text: 'alias',
            value: 'alias_name',
            width: '15%',
        },
        {
            text: 'nombre',
            value: 'name',
        },
        {
            text: 'cantidad',
            value: 'quantity',
            format: 'number',
            align: 'right',
            width: '15%',
            input: {
                type: 'float-field',
                reverse: true,
            },
        },
    ],

    //
    provider: [
        {
            text: 'rut',
            value: 'rut',
            width: '15%',
            format: 'rut',
        },
        {
            text: 'nombre',
            value: 'alias_name',
            width: '15%',
        },
        {
            text: 'sucursal',
            value: 'pch_provider_branch_offices_address',
            input: {
                custom: 'pch_provider_branch_offices_id',
                noDataText: 'Sin sucursales.',
                itemText: 'address',
                itemValue: 'id',
                renderItems: ({ item }) => item.branch_offices,
                type: 'select',
            },
        },
    ],
}
